export const adaptSocialPost = (data: ISocialPostFull): SocialPostFull => {
	return {
		id: data.id,
		body: data.body,
		publishedDate: data.published_date,
		author: data.author,
		authorName: data.author_name ?? null,
		authorRole: data.author_role ?? null,
		authorAvatarUrl: data.author_avatar_url ?? null,
		images: data.images ?? [],
		videos: data.videos ?? [],
		hashtags: data.hashtags ?? [],
		postToHashtags: data.post_to_hashtags ?? [],
		mentions: data.mentions ?? [],
		isSponsored: data.is_sponsored,
		sponsorName: data.sponsor_name,
		isTeamPost: data.is_team_post,
		commentsCount: data.comments_count ?? 0,
		reactionsCount: data.reactions_count ?? 0,
		userReaction: data.user_reaction ?? null,
		isSaved: data.is_saved,
		postType: data.post_type,
		sharedNewsArticleId: data.shared_news_article_id,
		externalLink: data.external_link
	};
};

export const adaptSocialPosts = (data: ISocialPostFull[]): SocialPostFull[] => {
	return data.map(adaptSocialPost);
};
